/**
 * Error handler passed into `onError` of <IntlProvider />
 * It's recommended to throw during development if id isn't found to catch missing translations
 * @param err error object thrown from IntlProvider
 */
export const onLocaleError = () => {
    // TODO [MEDIAWEBP-101] Handle IntlProvider Errors gracefully
    return null;
};
